<template>
  <BaseAction>
    <PrimaryButton light dense shrink @click.native="openDialog">
      Edit Basic Details
      <template v-slot:append:icon>
        <v-icon class="ml-2">mdi-pencil</v-icon>
      </template>
    </PrimaryButton>
    <EditInterviewFormatBasicDetailsDialog
      :interviewFormat="interviewFormat"
      @close="closeDialog"
      :isOpen="isOpen"
      v-if="isOpen"
    />
  </BaseAction>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import EditInterviewFormatBasicDetailsDialog from "@/views/bookings/BookingInterviews/components/dialogs/EditInterviewFormatBasicDetailsDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "EditInterviewFormatBasicDetailsAction",
  components: {
    EditInterviewFormatBasicDetailsDialog,
    PrimaryButton,
    BaseAction
  },
  props: {
    interviewFormat: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
